import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import economyReducers from "../reducers"

// Ask the server to take the money. A provider's SDK could capture in the browser and tell us it went
// well, and that is exactly the shape to avoid — the client would be the source of truth for
// whether it had paid. All this sends is the order id; what it was worth was written down when the
// payment was opened, and whether it was really paid is answered by the provider, server to server.
export const thunk = createAsyncThunk(
  "economy/captureOrder",
  async ({ orderId }, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(`/shop/orders/${orderId}/capture/`)
      // 202: captured, not cleared. Providers hold some payments for review and settle others over
      // days, and the server credits nothing until it completes. Reported as a distinct outcome
      // rather than as either success or failure — the player has paid and has no credits yet, and
      // both of the other two words for that are wrong.
      return {
        pending: response.status === 202,
        detail: response.data.detail,
        credits: response.data.credits,
        creditsAdded: response.data.credits_added ?? 0,
      }
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

// Only the balance. The catalogue did not change, and merging the whole payload would put
// `creditsAdded` and `pending` into the slice as though they were state rather than the answer to
// one request. On a pending capture the balance comes back unchanged, so this is a no-op there.
export const onSucceed = economyReducers.setCredits

const thunkObject = { thunk, onSucceed }
export default thunkObject
